const tableTitle = {
  buyVol: 'BUY VOL.',
  bid: 'BID',
  ask: 'ASK',
  sellVol: 'SELL VOL.',
  unmatchedBuyVol: 'TOTAL BUY VOL.',
  unmatchedSellVol: 'TOTAL SELL VOL.',
  totalMatchedVol: 'TOTAL MATCHED VOL.',
};

const relatedInformations = {
  bid: 'Bid',
  ask: 'Ask',
  frBuyVol: 'Foreign Buy Vol.',
  frSellVol: 'Foreign Sell Vol.',
  volume: 'Volume',
  avgPrice: 'Average Price',
  avgVol1m: 'Avg. Vol. 1M',
  avgVol10d: 'Avg. Vol. 10D',
  pe: 'P/E',
  beta: 'Beta',
  eps: 'EPS (VND/Share)',
  pb: 'P/B',
  marketCap: 'Market Cap (Bn.)',
  foreignOwner: '% Foreign Owner',
  ranking: 'Ranking',
  roe: 'ROE',
};

const action = {
  lvl1: 'Level 1',
  lvl2: 'Level 2',
  upgrade: 'UPGRADE',
  upgradeTitle: 'Unlock with FiinTrade Premium Account',
};

const groupButton = {
  buy: 'BUY',
  sell: 'SELL',
};

export default {
  tableTitle,
  relatedInformations,
  action,
  groupButton,
};
